module.exports = __webpack_public_path__ + "assets/003bb3fc77c27440a7ce050447022f54.mp3";